import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const HlsVideo: React.FC<{ slide: any }> = ({ slide }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(slide.src);
      hls.attachMedia(video);

      return () => {
        video.pause();
        hls.destroy();
      };
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = slide.src;
    }
  }, [slide.src]);

  return (
    <video
      id={`slider-video-${slide.id}`}
      ref={videoRef}
      controls
      playsInline
      style={{ width: "100%", maxHeight: "100%", outline: "none" }}
      poster={slide.poster}
    />
  );
}

export default HlsVideo;
